import React from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import harshithadoc from '../../../../assets/images/Doctorsimages/saiharishthadr.png'
import favicon from "../../../../assets/images/favicon.ico"
import AutoScrollImageRow from '../../AdvancedTreatmentsforHome/AutoScrollImageRow'
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const HarishithaDOc = () => {
  const navigate = useNavigate(); 
   useEffect(() => {
       document.title = "Dr. Sai Harshitha | Consultant Homoeopathy Physician in Guntur | Hcura Multispeciality Clinic";
       const metaDescription = document.querySelector("meta[name='description']");
       if (metaDescription) {
         metaDescription.setAttribute(
           "content",
           "Consult Dr. Sai Harshitha (BHMS), Consultant Homoeopathy Physician at Hcura Multispeciality Clinic, Guntur. Trained in emergency care and committed to individualised root-cause homoeopathic treatment for skin, hair, and chronic conditions. Book today."
         );
       }
       const metaKeywords = document.querySelector("meta[name='keywords']");
     if (metaKeywords) {
  metaKeywords.setAttribute(
    "content",
    "consultant homoeopathy doctor in Guntur, best homoeopathy physician in Guntur, homoeopathy doctor for skin treatment in Guntur, homoeopathy doctor for hair loss in Guntur, homoeopathy doctor for chronic diseases Guntur, individualised homoeopathy treatment Guntur, female homoeopathy doctor in Guntur, homoeopathy doctor near me Guntur, root cause homoeopathy doctor Guntur, homoeopathy clinic Guntur, homoeopathy doctor for lifestyle disorders Guntur, best homoeopathy physician near me, homoeopathy treatment for acne Guntur, homoeopathy doctor for pigmentation Guntur, homoeopathy doctor for hair fall Guntur"
  );
}

        // Set canonical link
        const existingCanonical = document.querySelector("link[rel='canonical']");
        if (existingCanonical) {
          existingCanonical.setAttribute("href", "https://www.h-cura.com/doctors/dr-sai-harshitha-guntur");
        } else {
          const canonicalLink = document.createElement("link");
          canonicalLink.setAttribute("rel", "canonical");
          canonicalLink.setAttribute("href", "https://www.h-cura.com/doctors/dr-sai-harshitha-guntur");
          document.head.appendChild(canonicalLink);
        }
        // Set favicon
     const existingFavicon = document.querySelector("link[rel='icon']");
     if (existingFavicon) {
       existingFavicon.setAttribute("href", favicon);
     } else {
       const faviconLink = document.createElement("link");
       faviconLink.setAttribute("rel", "icon");
       faviconLink.setAttribute("type", "image/x-icon");
       faviconLink.setAttribute("href", favicon);
       document.head.appendChild(faviconLink);
     }
     }, []);

const handleDownloadPdf = () => {
  const container = document.querySelector('.veenadoc');

  container.classList.add('veenadoc-pdf-mode');

  const originalStyles = new Map();

  const allElements = container.querySelectorAll('*');
  allElements.forEach(el => {
    originalStyles.set(el, {
      transition: el.style.transition,
      animation: el.style.animation,
      transform: el.style.transform,
      filter: el.style.filter
    });

    el.style.transition = 'none';
    el.style.animation = 'none';
    el.style.transform = 'none';
    el.style.filter = 'none';
  });

  const heroSection = container.querySelector('.veenadoc-hero-section');
  if (heroSection) {
    heroSection.style.minHeight = 'auto';
    heroSection.style.padding = '40px 0';
  }

  const images = container.querySelectorAll('img');
  images.forEach(img => {
    img.style.opacity = '1';
  });

  setTimeout(() => {
    html2canvas(container, {
      scale: 2,
      dpi: 300,
      useCORS: true,
      allowTaint: true,
      letterRendering: true,
      backgroundColor: '#ffffff',
      logging: false,
      windowWidth: container.scrollWidth,
      windowHeight: container.scrollHeight,
      scrollY: -window.scrollY,
      scrollX: -window.scrollX,
      imageTimeout: 0,
      removeContainer: false
    }).then(canvas => {
      container.classList.remove('veenadoc-pdf-mode');

      allElements.forEach(el => {
        const original = originalStyles.get(el);
        el.style.transition = original.transition;
        el.style.animation = original.animation;
        el.style.transform = original.transform;
        el.style.filter = original.filter;
      });

      if (heroSection) {
        heroSection.style.minHeight = '';
        heroSection.style.padding = '';
      }

      const imgData = canvas.toDataURL('image/jpeg', 0.95);
      const pdf = new jsPDF('p', 'mm', 'a4', true);

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;

      const marginLeft = 10; 
      const marginRight = 10; 
      const availableWidth = pdfWidth - marginLeft - marginRight;

      const scaleFactor = availableWidth / canvasWidth;

      const imgWidth = canvasWidth * scaleFactor;
      const imgHeight = canvasHeight * scaleFactor;

      const pages = Math.ceil(imgHeight / pdfHeight);

      for (let i = 0; i < pages; i++) {
        if (i > 0) {
          pdf.addPage();
        }
        pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
      }

      pdf.save('Dr.Sai_Harshitha_Profile.pdf');
    }).catch(error => {
      console.error('Error generating PDF:', error);
      alert('Failed to generate PDF. Please try again.');

      container.classList.remove('veenadoc-pdf-mode');

      if (heroSection) {
        heroSection.style.minHeight = '';
        heroSection.style.padding = '';
      }

      allElements.forEach(el => {
        const original = originalStyles.get(el);
        if (original) {
          el.style.transition = original.transition;
          el.style.animation = original.animation;
          el.style.transform = original.transform;
          el.style.filter = original.filter;
        }
      });
    });
  }, 100);
};

  return (
    <>
      <div className="veenadoc">
        {/* Hero Section */}
        <div className="veenadoc-hero-section">
          <div className="veenadoc-hero-background">
            <div className="veenadoc-wave-pattern">
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none">
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
            <div className="veenadoc-floating-shapes">
              <div className="veenadoc-shape veenadoc-shape-1"></div>
              <div className="veenadoc-shape veenadoc-shape-2"></div>
              <div className="veenadoc-shape veenadoc-shape-3"></div>
              <div className="veenadoc-shape veenadoc-shape-4"></div>
            </div>
          </div>

          <div className="veenadoc-container">
            <div className="veenadoc-hero-content">
              <div className="veenadoc-hero-left">
                <h1 className="veenadoc-hero-title">
                  <span className="veenadoc-title-highlight">Dr. Sai Harshitha</span>
                  <span className="veenadoc-title-credentials">(BHMS)</span>
                  <span className="veenadoc-title-location">Guntur</span>
                </h1>

                <div className="veenadoc-hero-description">
                  <p>
                    Dr. Sai Harshitha (BHMS) is a Consultant Homoeopathy Physician at Hcura Multispeciality Clinic, Guntur, known for her commitment to individualised care and root-cause healing. 
                    Trained in emergency care and committed to holistic treatment, she treats every patient according to their unique body, health history, and stage of illness.
                  </p>
                </div>

                <div className="veenadoc-hero-actions">
                  <button
                    className="veenadoc-btn-primary-gradient"
                    onClick={() => navigate('/bookconsultation')}
                  >
                    <span className="veenadoc-btn-icon">📞</span>
                    <span>Book Consultation</span>
                    <div className="veenadoc-btn-shine"></div>
                  </button>
                </div>
              </div>

              <div className="veenadoc-hero-right">
                <div className="veenadoc-doctor-showcase">
                  <div className="veenadoc-doctor-frame">
                    <div className="veenadoc-frame-glow"></div>
                    <div className="veenadoc-image-container">
                      <img src={harshithadoc} alt="Dr. Sai Harshitha – Consultant Homoeopathy Physician at Hcura Multispeciality Clinic Guntur" className="veenadoc-doctor-image" title='Dr. Sai Harshitha – Consultant Homoeopathy Physician at Hcura Multispeciality Clinic Guntur' />
                      <div className="veenadoc-image-overlay"></div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="veenadoc-article-section">
          <div className="veenadoc-container">
            <div className="veenadoc-article-layout">

              {/* Main Article Content */}
              <div className="veenadoc-article-main">

                {/* Introduction */}
                <div className="veenadoc-article-block">
                  <h2>About Dr. Sai Harshitha</h2>
                  <p>
                    Dr. Sai Harshitha completed her BHMS from NTR University, a well-regarded institution, where she gained strong knowledge in classical homoeopathy, patient assessment, and prescribing. 
                    She is also trained in Basic Life Support, reflecting her readiness to handle both routine consultations and medical emergencies safely.
                  </p>
                  <p>
                  Patients looking for a consultant homoeopathy doctor in Guntur who combines scientific precision with personal attention can trust Dr. Sai Harshitha, who believes every patient requires an individualized approach.
                  </p>
                </div>

                {/* Clinical Journey */}
                <div className="veenadoc-article-block">
                  <h2>Individualised Clinical Approach</h2>
                  <p>
                    Even with the same diagnosis like hair loss or acne, she does not prescribe the same remedy. She considers each individual’s body constitution, health history, and triggers. This individualised method forms the core of her practice.
                  </p>
                  <p>
                    Each patient is treated based on their body’s needs and the stage of the disease. She evaluates not just the condition but also its progression, as treatment varies accordingly. This thoughtful clinical approach reflects her depth and seriousness as a homoeopathy physician.
                  </p>
                </div>

               
                <div className="veenadoc-sidebar-card">
                  <h3>Quick Information</h3>
                  <div className="veenadoc-info-grid">
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Qualification:</span>
                      <span className="veenadoc-info-value">BHMS</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Specialization:</span>
                      <span className="veenadoc-info-value">Consultant Homoeopathy Physician</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Locations:</span>
                      <span className="veenadoc-info-value">Guntur</span>
                    </div>
                  </div>
                </div>
                <div className="veenadoc-article-block">
  <h2>Clinical Experience</h2>
  <p>
    She has hands-on experience of running her own homoeopathic clinic for 1 year, where she managed patient consultations, treatments, and follow-ups independently.
  </p>
  <p>
    During this period, she gained practical exposure in diagnosing various conditions and providing personalized treatment plans, strengthening her confidence and clinical decision-making skills.
  </p>
</div>

                {/* Expertise in Chronic Conditions */}
                <div className="veenadoc-article-block">
                  <h2>Expertise in Chronic & Lifestyle Diseases</h2>
                  <p>
                    Patients with chronic and recurring conditions often seek a doctor who truly understands their case. Dr. Sai Harshitha conducts detailed consultations, exploring the patient’s health history, past treatments, responses, and lifestyle factors.
                  </p>
                  <p>
                    She treats various conditions, including hormonal imbalances, immunity issues, and digestive problems. Her training and clinical experience help her manage conditions affecting multiple systems of the body.
                  </p>
                </div>

                {/* Skin Health */}
                <div className="veenadoc-article-block">
                  <h2>Skin Health Solutions</h2>
                  <p>
                    Skin conditions respond well to her individualised homoeopathic treatment. Whether it is acne, pigmentation, seasonal rashes, or eczema, she studies the pattern of the condition in each patient.
                  </p>
                  <p>
                    She connects skin issues with immunity, digestion, hormones, and emotional health before prescribing remedies that work internally. This provides a natural and long-lasting solution without side effects.
                  </p>
                </div>

                {/* Hair Health */}
                <div className="veenadoc-article-block">
                  <h2>Hair Care Expertise</h2>
                  <p>
                    Conditions like hair fall, thinning, premature greying, and dandruff are often linked to internal factors. She identifies whether the cause is stress, hormonal changes, nutrition, or underlying conditions, and prescribes accordingly.
                  </p>
                  <p>
                    This precise approach ensures long-term improvement rather than temporary results, addressing the root cause through tailored homoeopathic remedies.
                  </p>
                </div>

                {/* Patient Experience */}
                <div className="veenadoc-article-block">
                  <h2>Patient Experience & Care</h2>
                  <p>
                    Patients appreciate the attention they receive during consultations. She listens carefully, asks meaningful questions, and explains treatments clearly. Her Basic Life Support training further highlights her focus on patient safety and overall care.
                  </p>
                  <p>
                    At Hcura Multispeciality Clinic, she works in an integrated environment with dental, skin, and hair care services. This allows patients to receive complete care, combining homoeopathy with other specialised treatments when needed.
                  </p>
                </div>

                {/* Conclusion */}
                <div className="veenadoc-article-block veenadoc-conclusion-block">
                  <h2>Choose Dr. Sai Harshitha for Natural Healing</h2>
                  <p>
                    Choosing Dr. Sai Harshitha means choosing a physician who understands your health deeply and treats you as an individual. She combines strong clinical knowledge with a personalised approach to deliver natural and long-lasting healing.
                  </p>
                  <p>
                    Her dedication and care make her a growing and trusted name in homoeopathic medicine for residents of Guntur and surrounding areas.
                  </p>
                  <p className="veenadoc-mission-statement">
                    <strong>Her mission:</strong> To treat diseases from the root cause through an individualised approach that respects the uniqueness of every patient.
                  </p>
                </div>

              </div>

              {/* Sidebar */}
              <div className="veenadoc-article-sidebar">

                {/* Philosophy of Care */}
                <div className="veenadoc-article-block veenadoc-philosophy-block">
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">💫</div>
                    <blockquote>
                      "Homoeopathy treats diseases from the root cause through an individualised approach."
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. Sai Harshitha's Philosophy of Care</p>
                  </div>
                  <p>
                    She believes no two patients are the same, and therefore, no two treatments should be identical. Her practice is built on the core principle of individualised assessment.
                  </p>
                </div>

                {/* Locations */}
                <div className="veenadoc-sidebar-card">
                  <h3>Practice Locations</h3>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>Guntur</h4>
                      <p>Hcura Multispeciality Clinic</p>
                    </div>
                  </div>
                </div>

                {/* Contact CTA */}
                <div className="veenadoc-sidebar-card veenadoc-cta-card">
                  <h3>Book Your Consultation</h3>
                  <p>Experience personalized homoeopathic care with Dr. Sai Harshitha's root-cause approach.</p>
                 <button
                  className="veenadoc-sidebar-btn-primary"
                  onClick={() => window.location.href = 'tel:+918870001377'}
                >
                  <span>📞</span>
                  <span>Schedule Appointment</span>
                </button>
                <button
                  className="veenadoc-sidebar-btn-secondary"
                  onClick={() => window.location.href = 'tel:+918870001377'}
                >
                  <span>💬</span>
                  <span>Get Free Assessment</span>
                </button>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>

      <AutoScrollImageRow/>

       <div className="bangloregfcblog-download-section">
            <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
              Download This Doctor profile as PDF
            </button>
          </div>
    </>
  )
}

export default HarishithaDOc
